// libs
import replaceAsciiEmojis from 'emoji-shortcuts'
import * as React from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import {
  DisplaySettings,
  mapDisplayModeToConst,
  POST_DISPLAY_MODE_DETAIL,
  PostDisplayMode,
  Purpose
} from 'src/interfaces/posts'

// classes
import BlurredContent, {
  IBlurred
} from 'src/components/blurred_content/blurred_content'

// helpers
import { escapeForMarkup } from 'src/utils/safe_url/safe_url'
import { makeHTMLLinksFromText } from 'src/utils/string/string'

// styles
import NavigationItem from 'src/components/navigation_item/navigation_item'
import './body_text.scss'

export const _classPrefix = `${CLASS_PREFIX}body-text__`

type BodyTextSettings = {
  show: boolean;
};

const _settings: DisplaySettings<BodyTextSettings> = {
  admin: {
    basic_ingredient: { show: true }
  },
  banner: {
    basic_ingredient: { show: false }
  },
  compact: {
    basic_ingredient: { show: false }
  },
  detail: {
    basic_ingredient: { show: true }
  },
  preview: {
    basic_ingredient: { show: true }
  }
}

export type IProps = {
  blurred?: IBlurred;
  displayMode: PostDisplayMode;
  postDetailsURL?: string;
  purpose: Purpose;
  teaserContent?: string | null;
  text: string;
};

export default class BodyText extends React.PureComponent<IProps> {
  private cls = ''

  constructor (props: IProps) {
    super(props)
    this.cls = `${_classPrefix}${mapDisplayModeToConst[props.displayMode]}`
  }

  public render () {
    const {
      blurred = false,
      displayMode,
      postDetailsURL,
      purpose,
      teaserContent,
      text
    } = this.props

    const parsedBody: string =
      displayMode === POST_DISPLAY_MODE_DETAIL
        ? this.parseContent(text)
        // Only this branch: the detail branch escapes inside
        // makeHTMLLinksFromText, and escaping twice would turn its anchors
        // into visible source.
        : escapeForMarkup(replaceAsciiEmojis(teaserContent ?? ''))
    const bodyElement = <p dangerouslySetInnerHTML={{ __html: parsedBody }} />

    const settings = _settings[displayMode][purpose]

    return settings?.show
      ? (
        <NavigationItem target='_self' url={postDetailsURL} >

          <div className={this.cls}>
            {blurred ? <BlurredContent>{bodyElement}</BlurredContent> : bodyElement}
          </div>
        </NavigationItem>
      )
      : null
  }

  private parseContent (content: string): string {
    const afterLinksParse: string = makeHTMLLinksFromText(
      replaceAsciiEmojis(content)
    )

    return afterLinksParse
  }
}
